import { IUploadInputProps } from "./UploadInputTypes"
import { useRef } from "react"
import { Input as ChakraInput, Flex, Center, Text, Box, Image, Button, } from "@chakra-ui/react"
import { AiOutlineCheck } from "react-icons/ai"
import FormLabel from "components/UI/atoms/FormLabel"
import Icon from "components/UI/atoms/Icon"
import Popover from "components/UI/atoms/Popover"

const UploadInput: React.FC<IUploadInputProps> = ({
  name,
  value,
  onChange,
  file,
  fileType,
  accept,
  inputLabel,
  inputStyles,
  onRemove,
  label,
  helper,
  error,
  imageUrl,
  onClick,
}) => {

const inputRef = useRef<HTMLInputElement>(null)
  
const clearValue = () => {
  if(inputRef.current !== null) {
    inputRef.current.value = ""
  } 
}



  const renderImagePreview = (imageUrl: string) => {
    return <Box w="80px" h="90%" overflow="hidden">
      <Image cursor="pointer" w="100%" h="100%" objectFit="cover" src={imageUrl} onClick={() => {onRemove(),clearValue()}}/>
    </Box>
  }
  return (
    <>
      {label && <FormLabel id={name} text={label} color={`${error ? "error" : "main_text_color"}`} />}
      <ChakraInput
        ref={inputRef}
        id="upload-input"
        variant={file ? "filled" : "dashed"}
        name={name}
        onClick={onClick}
        // value
        onChange={onChange}
        type="file"
        hidden
        accept={accept}
      />
      <Flex
        backgroundColor={file ? "#E9F2FD" : "#fff"}
        width="100%"
        height="100%"
        border={`2px ${file ? "solid" : "dashed"}`}
        borderColor={error ? "error" : "input_border_color_primary"}
        borderRadius="base"
        alignItems="center"
        padding="0 20px"
        {...inputStyles}
      >
        
        <Flex justifyContent="space-between" alignItems="center" width="100%" height="100%">
          
          {file && fileType === "IMAGE" && imageUrl && renderImagePreview(imageUrl)}
          {!file && (
            <Flex
              alignItems="center"
              as="label"
              htmlFor="upload-input"
              cursor="pointer"
            >
              <Center w="34px" h="34px" borderRadius="50%" bg="primary">
                <Icon name="picture" />
              </Center>
              <Text fontSize="m" ml="15px">
                {inputLabel}
              </Text>
            </Flex>
          )}
          
          {(helper && !file) ? (
            <Popover
              rootElement={
                <Center
                  w="34px"
                  h="34px"
                  borderRadius="50%"
                  bg="input_border_color_primary"
                  as="button"
                >
                  <Icon name="info" iconStyles={{ fill: "#00000" }} />
                </Center>
              }
              content={helper}
              placement="top-start"
              trigger="hover"
            />
          ) : <Center
          justifyContent="flex-end"
          gap={5}
          w="70px"
          h="100%"
          borderRadius="50%"
        >
          <Center as="button" onClick={() => {onRemove(),clearValue()}}>
          <Icon name="delete" iconStyles={{fill: "red", height: "1.75rem", width: "1.563rem"}} />
          </Center>
          <AiOutlineCheck color="var(--chakra-colors-primary)" size={65} />
        </Center>
              
          }
        </Flex>
      </Flex>
      {error && (
        <Text color="error" fontSize="base">
          {error}
        </Text>
      )}
    </>
  )
}

export default UploadInput
